
export const PRIORITY_ITEMS = ['Low', 'Normal', 'High'];
export const STATUS_ITEMS = ['Open', 'In Progress', 'Deferred', 'Completed'];

export const ANALYTICS_PERIODS = {
  Week: {
    period: '2020-01-24/2020-01-31',
    index: 0,
  },
  '2 Weeks': {
    period: '2020-01-14/2020-01-31',
    index: 1,
  },
  Month: {
    period: '2020-01-01/2020-02-01',
    index: 2,
  },
  Year: {
    period: '2020-01-01/2021-01-01',
    index: 3,
  },
  All: {
    period: '2018-01-01/2022-01-01',
    index: 4,
  },
};

export const DEFAULT_ANALYTICS_PERIOD_KEY = 'All';

export const ATHLETE_STATUS_LIST = [
  'aktiv',
  'ausgetreten',
  'ruhend',
];
export const USER_STATUS_LIST = [
  'aktiv',
  'inaktiv',

];

export const COMPETITION_STATUS_LIST = [
  'Meldung möglich',
  'Meldung abgeschlossen',
  'Ergebnisse vorhanden',
];
export const COMPETITION_ATHLETE_STATUS_LIST = [
  'offen',
  'vollständig',
  'keine Teilnahme',
  'gemeldet'
];

export const GENDERS = [
  { id: 0, text: 'männlich' },
  { id: 1, text: 'weiblich' },
  { id: 2, text: 'divers' },
  { id: 3, text: 'mixed' }
];

export const COURSES = [
  { id: 0, text: '25' },
  { id: 1, text: '50' },
  { id: 2, text: 'FW' }
];;
export const TIMEKEEPING = [
  "AUTOMATISCH", "HALBAUTOMATISCH", "HANDZEITNAHME"
];

export const exportFormats = ['xlsx', 'pdf'];

export const  STROKES = [
  { id: 'freestyle', text: 'Freistil' },
  { id: 'backstroke', text: 'Rücken' },
  { id: 'breaststroke', text: 'Brust' },
  { id: 'butterfly', text: 'Schmetterling' },
  { id: 'medley', text: 'Lagen' }
];

export const NATIONS = [
  // Afrika
  { id: 'ALG', text: 'Algerien' },
  { id: 'ANG', text: 'Angola' },
  { id: 'BDI', text: 'Burundi' },
  { id: 'BEN', text: 'Benin' },
  { id: 'BOT', text: 'Botswana' },
  { id: 'BUR', text: 'Burkina Faso' },
  { id: 'CAF', text: 'Zentralafrikanische Republik' },
  { id: 'CGO', text: 'Kongo' },
  { id: 'CHA', text: 'Tschad' },
  { id: 'CIV', text: 'Elfenbeinküste' },
  { id: 'CMR', text: 'Kamerun' },
  { id: 'COD', text: 'DR Kongo' },
  { id: 'COM', text: 'Komoren' },
  { id: 'CPV', text: 'Kap Verde' },
  { id: 'DJI', text: 'Dschibuti' },
  { id: 'EGY', text: 'Ägypten' },
  { id: 'ERI', text: 'Eritrea' },
  { id: 'ETH', text: 'Äthiopien' },
  { id: 'GAB', text: 'Gabun' },
  { id: 'GAM', text: 'Gambia' },
  { id: 'GBS', text: 'Guinea-Bissau' },
  { id: 'GEQ', text: 'Äquatorialguinea' },
  { id: 'GHA', text: 'Ghana' },
  { id: 'GUI', text: 'Guinea' },
  { id: 'KEN', text: 'Kenia' },
  { id: 'LBA', text: 'Libyen' },
  { id: 'LBR', text: 'Liberia' },
  { id: 'LES', text: 'Lesotho' },
  { id: 'MAD', text: 'Madagaskar' },
  { id: 'MAR', text: 'Marokko' },
  { id: 'MAW', text: 'Malawi' },
  { id: 'MLI', text: 'Mali' },
  { id: 'MOZ', text: 'Mosambik' },
  { id: 'MRI', text: 'Mauritius' },
  { id: 'MTN', text: 'Mauretanien' },
  { id: 'NAM', text: 'Namibia' },
  { id: 'NGR', text: 'Nigeria' },
  { id: 'NIG', text: 'Niger' },
  { id: 'RSA', text: 'Südafrika' },
  { id: 'RWA', text: 'Ruanda' },
  { id: 'SEN', text: 'Senegal' },
  { id: 'SEY', text: 'Seychellen' },
  { id: 'SLE', text: 'Sierra Leone' },
  { id: 'SOM', text: 'Somalia' },
  { id: 'STP', text: 'São Tomé und Príncipe' },
  { id: 'SUD', text: 'Sudan' },
  { id: 'SWZ', text: 'Eswatini' },
  { id: 'TAN', text: 'Tansania' },
  { id: 'TOG', text: 'Togo' },
  { id: 'TUN', text: 'Tunesien' },
  { id: 'UGA', text: 'Uganda' },
  { id: 'ZAM', text: 'Sambia' },
  { id: 'ZIM', text: 'Simbabwe' },
  // Amerika
  { id: 'AGU', text: 'Anguilla' },
  { id: 'ANT', text: 'Antigua und Barbuda' },
  { id: 'ARG', text: 'Argentinien' },
  { id: 'ARU', text: 'Aruba' },
  { id: 'BAH', text: 'Bahamas' },
  { id: 'BAR', text: 'Barbados' },
  { id: 'BER', text: 'Bermuda' },
  { id: 'BIZ', text: 'Belize' },
  { id: 'BOL', text: 'Bolivien' },
  { id: 'BRA', text: 'Brasilien' },
  { id: 'CAN', text: 'Kanada' },
  { id: 'CAY', text: 'Kaimaninseln' },
  { id: 'CHI', text: 'Chile' },
  { id: 'COL', text: 'Kolumbien' },
  { id: 'CRC', text: 'Costa Rica' },
  { id: 'CUB', text: 'Kuba' },
  { id: 'CUR', text: 'Curaçao' },
  { id: 'DMA', text: 'Dominica' },
  { id: 'DOM', text: 'Dominikanische Republik' },
  { id: 'ECU', text: 'Ecuador' },
  { id: 'ESA', text: 'El Salvador' },
  { id: 'GRN', text: 'Grenada' },
  { id: 'GUA', text: 'Guatemala' },
  { id: 'GUY', text: 'Guyana' },
  { id: 'HAI', text: 'Haiti' },
  { id: 'HON', text: 'Honduras' },
  { id: 'ISV', text: 'Amerikanische Jungferninseln' },
  { id: 'IVB', text: 'Britische Jungferninseln' },
  { id: 'JAM', text: 'Jamaika' },
  { id: 'LCA', text: 'St. Lucia' },
  { id: 'MAA', text: 'Sint Maarten' },
  { id: 'MEX', text: 'Mexiko' },
  { id: 'NCA', text: 'Nicaragua' },
  { id: 'PAN', text: 'Panama' },
  { id: 'PAR', text: 'Paraguay' },
  { id: 'PER', text: 'Peru' },
  { id: 'PUR', text: 'Puerto Rico' },
  { id: 'SKN', text: 'St. Kitts und Nevis' },
  { id: 'SUR', text: 'Suriname' },
  { id: 'TCN', text: 'Turks- und Caicosinseln' },
  { id: 'TTO', text: 'Trinidad und Tobago' },
  { id: 'URU', text: 'Uruguay' },
  { id: 'USA', text: 'Vereinigte Staaten' },
  { id: 'VEN', text: 'Venezuela' },
  { id: 'VIN', text: 'St. Vincent und die Grenadinen' },
  // Asien
  { id: 'AFG', text: 'Afghanistan' },
  { id: 'BAN', text: 'Bangladesch' },
  { id: 'BHU', text: 'Bhutan' },
  { id: 'BRN', text: 'Bahrain' },
  { id: 'BRU', text: 'Brunei' },
  { id: 'CAM', text: 'Kambodscha' },
  { id: 'CHN', text: 'China' },
  { id: 'HKG', text: 'Hongkong' },
  { id: 'INA', text: 'Indonesien' },
  { id: 'IND', text: 'Indien' },
  { id: 'IRI', text: 'Iran' },
  { id: 'IRQ', text: 'Irak' },
  { id: 'JOR', text: 'Jordanien' },
  { id: 'JPN', text: 'Japan' },
  { id: 'KAZ', text: 'Kasachstan' },
  { id: 'KGZ', text: 'Kirgisistan' },
  { id: 'KOR', text: 'Südkorea' },
  { id: 'KSA', text: 'Saudi-Arabien' },
  { id: 'KUW', text: 'Kuwait' },
  { id: 'LAO', text: 'Laos' },
  { id: 'LBN', text: 'Libanon' },
  { id: 'MAC', text: 'Macau' },
  { id: 'MAS', text: 'Malaysia' },
  { id: 'MDV', text: 'Malediven' },
  { id: 'MGL', text: 'Mongolei' },
  { id: 'MYA', text: 'Myanmar' },
  { id: 'NEP', text: 'Nepal' },
  { id: 'OMA', text: 'Oman' },
  { id: 'PAK', text: 'Pakistan' },
  { id: 'PHI', text: 'Philippinen' },
  { id: 'PLE', text: 'Palästina' },
  { id: 'PRK', text: 'Nordkorea' },
  { id: 'QAT', text: 'Katar' },
  { id: 'SGP', text: 'Singapur' },
  { id: 'SRI', text: 'Sri Lanka' },
  { id: 'SYR', text: 'Syrien' },
  { id: 'THA', text: 'Thailand' },
  { id: 'TJK', text: 'Tadschikistan' },
  { id: 'TKM', text: 'Turkmenistan' },
  { id: 'TLS', text: 'Timor-Leste' },
  { id: 'TPE', text: 'Chinesisch Taipeh' },
  { id: 'UAE', text: 'Vereinigte Arabische Emirate' },
  { id: 'UZB', text: 'Usbekistan' },
  { id: 'VIE', text: 'Vietnam' },
  { id: 'YEM', text: 'Jemen' },
  // Europa
  { id: 'ALB', text: 'Albanien' },
  { id: 'AND', text: 'Andorra' },
  { id: 'ARM', text: 'Armenien' },
  { id: 'AUT', text: 'Österreich' },
  { id: 'AZE', text: 'Aserbaidschan' },
  { id: 'BEL', text: 'Belgien' },
  { id: 'BIH', text: 'Bosnien und Herzegowina' },
  { id: 'BLR', text: 'Belarus' },
  { id: 'BUL', text: 'Bulgarien' },
  { id: 'CRO', text: 'Kroatien' },
  { id: 'CYP', text: 'Zypern' },
  { id: 'CZE', text: 'Tschechien' },
  { id: 'DEN', text: 'Dänemark' },
  { id: 'ESP', text: 'Spanien' },
  { id: 'EST', text: 'Estland' },
  { id: 'FIN', text: 'Finnland' },
  { id: 'FRA', text: 'Frankreich' },
  { id: 'FRO', text: 'Färöer' },
  { id: 'GBR', text: 'Großbritannien' },
  { id: 'GEO', text: 'Georgien' },
  { id: 'GER', text: 'Deutschland' },
  { id: 'GIB', text: 'Gibraltar' },
  { id: 'GRE', text: 'Griechenland' },
  { id: 'HUN', text: 'Ungarn' },
  { id: 'IRL', text: 'Irland' },
  { id: 'ISL', text: 'Island' },
  { id: 'ISR', text: 'Israel' },
  { id: 'ITA', text: 'Italien' },
  { id: 'KOS', text: 'Kosovo' },
  { id: 'LAT', text: 'Lettland' },
  { id: 'LIE', text: 'Liechtenstein' },
  { id: 'LTU', text: 'Litauen' },
  { id: 'LUX', text: 'Luxemburg' },
  { id: 'MDA', text: 'Moldau' },
  { id: 'MKD', text: 'Nordmazedonien' },
  { id: 'MLT', text: 'Malta' },
  { id: 'MNE', text: 'Montenegro' },
  { id: 'MON', text: 'Monaco' },
  { id: 'NED', text: 'Niederlande' },
  { id: 'NOR', text: 'Norwegen' },
  { id: 'POL', text: 'Polen' },
  { id: 'POR', text: 'Portugal' },
  { id: 'ROU', text: 'Rumänien' },
  { id: 'RUS', text: 'Russland' },
  { id: 'SLO', text: 'Slowenien' },
  { id: 'SMR', text: 'San Marino' },
  { id: 'SRB', text: 'Serbien' },
  { id: 'SUI', text: 'Schweiz' },
  { id: 'SVK', text: 'Slowakei' },
  { id: 'SWE', text: 'Schweden' },
  { id: 'TUR', text: 'Türkei' },
  { id: 'UKR', text: 'Ukraine' },
  // Ozeanien
  { id: 'ASA', text: 'Amerikanisch-Samoa' },
  { id: 'AUS', text: 'Australien' },
  { id: 'COK', text: 'Cookinseln' },
  { id: 'FIJ', text: 'Fidschi' },
  { id: 'FSM', text: 'Mikronesien' },
  { id: 'GUM', text: 'Guam' },
  { id: 'MHL', text: 'Marshallinseln' },
  { id: 'NMA', text: 'Nördliche Marianen' },
  { id: 'NZL', text: 'Neuseeland' },
  { id: 'PLW', text: 'Palau' },
  { id: 'PNG', text: 'Papua-Neuguinea' },
  { id: 'SAM', text: 'Samoa' },
  { id: 'SOL', text: 'Salomonen' },
  { id: 'TGA', text: 'Tonga' },
  { id: 'VAN', text: 'Vanuatu' },
];
